<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<header>
<h1 class="topictitle1" id="fo2"><a href="#/nav#nfo2"><span class="title">Foreword</span><br/><span class="subtitle">A True American Treasure</span><br/><span class="author">David Foster</span></a></h1>
</header>
<p>Music history will affirm Maurice White’s unique contribution to rock and roll. Most will extol his many hit records, his
            leadership abilities, or his God-given talents as a producer, drummer, and singer, but it would be a disservice to limit his
            contributions to these well-known accomplishments. Maurice White was more; he was a catalyst. Through his creation of Earth,
            Wind &amp; Fire, he changed the musical and performance landscape of pop music forever.
         </p>
<p>It was foredestined that the first of my sixteen Grammys should be awarded for the song “After the Love Is Gone,” not because
            the song meant more to me than other hits that would come later, but because the song was my vehicle into the world of my
            mentor, hero, and friend Maurice White.
         </p>
<p>I first met Maurice in early 1978. I was a session musician and arranger then, and had just started to produce records of
            my own. When I sat down at the piano and played “After the Love Is Gone” for Maurice, it was a life-altering moment for me.
         </p>
<p>I believe Maurice and I hit it off so well because we both believe that being a good musician is a fine thing, but greatness
            is always the goal. In fact, my mantra is that good is the enemy of great. As I expected, I saw nothing but greatness in him
            during our first meeting; I somehow knew being around him would make me better. When you come from Canada, as I do, you have
            to work twice as hard to be taken half as seriously as a musician, and my work benefited from the ultimate guide—the music
            of Earth, Wind &amp; Fire. I learned so much about how to fuse the different genres of R&amp;B, jazz, and classical and still retain
            my own signature in the final product.
         </p>
<p>I was also a normal, everyday fan, one of those thousands of people who stood in line at Tower Records in Hollywood so that
            one minute after midnight I could get the next Earth, Wind &amp; Fire album.
         </p>
<p>For so very long I wanted to tell the world about Maurice’s contribution to my life. At one point I entertained the idea of
            having a big testimonial dinner in his honor. I should have known: Maurice, being the very private man he is, wasn’t having
            any of that. But in October of 2010, at my latest <i>David Foster &amp; Friends</i> television special for PBS, I finally did get the chance to publicly tell him, and the world, how I felt. I think my words
            that night summed it up:
         </p>
<blockquote class="extract_group">
<p class="extract">There is also someone here tonight, a man who taught me more about making music, about decency, about calmness, about well-being,
               and about the true spirit of music than any other human being on the planet.
            </p>
<p class="extract">One thing I know for sure, if he hadn’t been born, pop music would sound a lot different today. That man is the genius behind
               Earth, Wind &amp; Fire. Ladies and gentlemen, he’s here with us tonight in a rare public appearance—Maurice White, my hero, my
               mentor, and a true American treasure.
            </p>
</blockquote>
<p>That was a special moment for me: cliché as it may be, I think it’s important to give credit to those on whose shoulders you
            stand, and—when life permits it—to give that credit directly, face to face with the ones you owe. As you might imagine, being
            able to do that in person in front of eight thousand people felt better for me than it probably did for Maurice.
         </p>
<p>Now, after reading Maurice’s memoir, I finally understand how a humble Memphis upbringing gave the world the electrifying
            and optimistic music of Earth, Wind &amp; Fire. His story is not a lurid rock-and-roll story about “the leader of the band” but
            a subtle, beautifully told one about clarity, core motivations, courage, and, above all, music—all told through the eyes of
            a private man dedicated to using music to lift the spirit of the listening world.
         </p>
<p>This textured narrative is a testament to the musical boundaries Maurice White erased and the different people he brought
            together, a testament that shows who he is personally and professionally. For me, it recalls the many creative bursts we shared—moments
            I will always cherish.
         </p>
<p>This is the story of a true American treasure indeed.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?1be5f9e5